import { server } from 'helpers/config';

const SERVER_URL = server.apiHost;

export default {
  BUSINESS_ADMIN: `${SERVER_URL}/business-admin/`,
};
